import { Injectable } from '@angular/core';
import { ClientConstantType } from './client.constant';
import { ClientSetup } from './classes/client-setup.interface';
import { environment } from '@env/environment';

/**
 * Import all the cient setup files
 */
import { wastemanagement_ClientSetup } from './clients/wastemanagement/client-setup';
import { default_ClientSetup } from './clients/default/client-setup';

/**
 * Map all the available clients and their setup
 */
const availableClients: { [key: string]: { setup: ClientSetup; client: ClientConstantType } } = {
  wastemanagement: {
    setup: wastemanagement_ClientSetup,
    client: ClientConstantType.wastemanagement,
  },
  paepae: {
    setup: default_ClientSetup,
    client: ClientConstantType.paepae,
  },
  waikatotainui: {
    setup: default_ClientSetup,
    client: ClientConstantType.waikatotainui,
  },
  tahaaroa: {
    setup: default_ClientSetup,
    client: ClientConstantType.tahaaroa,
  },
  patuharakeke: {
    setup: default_ClientSetup,
    client: ClientConstantType.patuharakeke,
  },
  waitaha: {
    setup: default_ClientSetup,
    client: ClientConstantType.waitaha,
  },
  ngatiawataikapiti: {
    setup: default_ClientSetup,
    client: ClientConstantType.ngatiawataikapiti,
  },
  kapiti: {
    setup: default_ClientSetup,
    client: ClientConstantType.kapiti,
  },
  ngatikuri: {
    setup: default_ClientSetup,
    client: ClientConstantType.ngatikuri,
  },
  maahanga: {
    setup: default_ClientSetup,
    client: ClientConstantType.maahanga,
  },
  tapuika: {
    setup: default_ClientSetup,
    client: ClientConstantType.tapuika,
  },
  ngatihauiti: {
    setup: default_ClientSetup,
    client: ClientConstantType.ngatihauiti,
  },
  ngawairikingatiapa: {
    setup: default_ClientSetup,
    client: ClientConstantType.ngawairikingatiapa,
  },
  ranana: {
    setup: default_ClientSetup,
    client: ClientConstantType.ranana,
  },
  ngatimanuhiri: {
    setup: default_ClientSetup,
    client: ClientConstantType.ngatimanuhiri,
  },
  ngatiira: {
    setup: default_ClientSetup,
    client: ClientConstantType.ngatiira,
  },
  hurakiatrust: {
    setup: default_ClientSetup,
    client: ClientConstantType.hurakiatrust,
  },
  tearataki: {
    setup: default_ClientSetup,
    client: ClientConstantType.tearataki,
  },
  teuriohau: {
    setup: default_ClientSetup,
    client: ClientConstantType.teuriohau,
  },
  raukawa: {
    setup: default_ClientSetup,
    client: ClientConstantType.raukawa,
  },
  default: {
    setup: default_ClientSetup,
    client: ClientConstantType.default,
  },
};

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private client: ClientConstantType;
  private clientSetup: ClientSetup;
  private originIdentifier: string;

  constructor() {
    let subdomain = environment.forceBrand || window.location.host.split(/\.|:/g)[0];
    const selectedClient = availableClients[subdomain] || availableClients.default;
    this.clientSetup = selectedClient.setup;
    this.originIdentifier = environment.forceBrand || subdomain;
    this.client = selectedClient.client;
  }

  getClient(): ClientConstantType {
    return this.client;
  }

  getClientOriginIdentifier(): string {
    return this.originIdentifier;
  }

  getClientSetup(): ClientSetup {
    return this.clientSetup;
  }
}
